import { Tooltip } from '@bryntum/schedulerpro';
import { useEffect } from 'react';
import { SchedulerReference } from 'components/organisms/resource-management/types';
import { useTranslate } from 'hooks/use-translation';
import { tooltipForAutoAllocate } from '../templates/auto-allocation-tooltip';

export const useAutoAllocateTooltip = (ref: SchedulerReference): void => {
  const translate = useTranslate();

  useEffect(() => {
    const tooltip = new Tooltip({
      forSelector:
        '.b-grid-subgrid-normal .b-grid-row:not(.project:not(.people-view)).auto-allocate',
      maxWidth: 240,
      getHtml: () => {
        return tooltipForAutoAllocate(translate);
      },
      hoverDelay: 800,
      hideDelay: 100,
      constrainTo: ref.current.instance.timeAxisSubGridElement,
    });

    return () => {
      tooltip.destroy();
    };
  }, [ref, translate]);
};
